import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "stepIndicator", "nextButton", "backButton", "submitButton"]
  static values = { currentStep: { type: Number, default: 1 }, totalSteps: Number }

  connect() {
    this.showStep(this.currentStepValue)
  }

  next() {
    if (this.validateCurrentStep()) {
      this.currentStepValue = Math.min(this.currentStepValue + 1, this.totalStepsValue)
      this.showStep(this.currentStepValue)
    }
  }

  back() {
    this.currentStepValue = Math.max(this.currentStepValue - 1, 1)
    this.showStep(this.currentStepValue)
  }

  goToStep(event) {
    const step = parseInt(event.currentTarget.dataset.step)
    if (step < this.currentStepValue || this.validateCurrentStep()) {
      this.currentStepValue = step
      this.showStep(this.currentStepValue)
    }
  }

  showStep(step) {
    this.stepTargets.forEach((stepElement, index) => {
      const stepNumber = index + 1
      if (stepNumber === step) {
        stepElement.classList.remove("hidden")
      } else {
        stepElement.classList.add("hidden")
      }
    })

    this.updateIndicators(step)
    this.updateButtons(step)
  }

  updateIndicators(currentStep) {
    this.stepIndicatorTargets.forEach((indicator, index) => {
      const stepNumber = index + 1
      indicator.classList.remove("step-active", "step-completed", "step-upcoming")

      if (stepNumber === currentStep) {
        indicator.classList.add("step-active")
      } else if (stepNumber < currentStep) {
        indicator.classList.add("step-completed")
      } else {
        indicator.classList.add("step-upcoming")
      }
    })
  }

  updateButtons(step) {
    const isFirstStep = step === 1
    const isLastStep = step === this.totalStepsValue

    if (this.hasBackButtonTarget) {
      this.backButtonTarget.classList.toggle("hidden", isFirstStep)
    }

    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.classList.toggle("hidden", isLastStep)
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.classList.toggle("hidden", !isLastStep)
    }
  }

  validateCurrentStep() {
    const currentStepElement = this.stepTargets[this.currentStepValue - 1]
    const requiredInputs = currentStepElement.querySelectorAll("[required]")

    let isValid = true
    requiredInputs.forEach(input => {
      if (!input.value.trim()) {
        isValid = false
        input.classList.add("border-red-500")
        input.addEventListener("input", () => input.classList.remove("border-red-500"), { once: true })
      }
    })

    return isValid
  }
}
